import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle mb-15">
                    Optimize evergreen articles that have been declining over the past few weeks. We
                    have selected the top 100 evergreen articles over the past 365 days.
                </div>
            </>
        );
    }
}

export default ExtraButtons;
